'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstTab = function (_VstComponent) {
  _inherits(VstTab, _VstComponent);

  function VstTab() {
    _classCallCheck(this, VstTab);

    var _this = _possibleConstructorReturn(this, (VstTab.__proto__ || Object.getPrototypeOf(VstTab)).call(this));

    _this.tabTo = _this.tabTo.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    return _this;
  }

  _createClass(VstTab, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.active && this.props.active) {
        this.tab.focus();
      }
    }

    // I added this so routing in mulligan didn't have to change much, but ideally tabs wouldn't change the url

  }, {
    key: 'tabTo',
    value: function tabTo() {
      var _props = this.props,
          href = _props.href,
          onClick = _props.onClick;

      if (href) {
        window.location.assign(href);
      }
      onClick();
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (e.keyCode === 37 || e.keyCode === 38) {
        this.props.onPreviousTab();
      } else if (e.keyCode === 39 || e.keyCode === 40) {
        this.props.onNextTab();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'li',
        _extends({ role: 'presentation' }, (0, _copyProps2.default)(this.props, ['active', 'onClick', 'href', 'onPreviousTab', 'onNextTab']), { className: (0, _classnames2.default)('vst-tab', { active: this.props.active }) }),
        _react2.default.createElement(
          'a',
          {
            'aria-selected': this.props.active,
            onClick: this.tabTo, className: 'vst-link',
            ref: function ref(tab) {
              _this2.tab = tab;
            },
            role: 'tab',
            tabIndex: this.props.active ? 0 : -1,
            onKeyDown: this.onKeyDown
          },
          this.props.children
        )
      );
    }
  }]);

  return VstTab;
}(_VstComponent3.default);

exports.default = VstTab;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTab.js
 **/